import type { ReactNode } from 'react'
import React, { useContext as useContextCore, useState } from 'react'
import { useGeneralSearchOnBoarding } from './onboard/useGenralSearchOnBoarding'

type GeneralSearchContextType = {
  search: string
  setSearch: (value: string) => void
  onBoarding: ReturnType<typeof useGeneralSearchOnBoarding>
  showOnBoarding: boolean
}

const context = React.createContext<GeneralSearchContextType>({} as GeneralSearchContextType)
const CoreProvider = context.Provider

type ProviderProps = {
  children?: ReactNode
  initialSearch?: string
}

export const Provider = ({ children, initialSearch = '' }: ProviderProps) => {
  //the state fof onboarding
  const showOnBoarding = true

  const onBoarding = useGeneralSearchOnBoarding({ enabled: showOnBoarding })

  const [search, setSearch] = useState<string>(initialSearch)

  return <CoreProvider value={{ search, setSearch, onBoarding, showOnBoarding }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
export const useGeneralSearchContext = () => useContextCore(context)
